import { css } from '@emotion/core'
import styled, { Theme } from '@themes/theme'
import { Right } from '@styles/base.style'

export const FilterHeader = styled.div`
  .reset-btn {
    position: absolute;
    top: 9px;
    left: 8px;
    width: 45px;
    height: 45px;
    svg {
      width: 24px;
      height: auto;
      .arrow {
        fill: ${props => props.theme.color.modalDarkBg}
      }
      .bg {
        fill: ${props => props.theme.color.modalBg}
      }
    }
    &.active {
      svg {
        .arrow {
          fill: ${props => props.theme.color.mainBg}
        }
        .bg {
          fill: ${props => props.theme.color.modalSubBg2}
        }
      }
    }
  }
`

export const FilterList = (theme: Theme) => css`
  &.filter-list {
    border: none;
    .ant-list-header {
      padding: 20px 0 12px;
      background: ${theme.color.themeTxt};
      border-bottom: 1px solid ${theme.color.modalBg};
      border-radius: 18px 18px 0 0;
      & div {
        color: ${theme.color.modalTxt};
        font-size: ${theme.font.title};
      }
    }
    .ant-list-items {
      min-height: 250px;
      max-height: 356px;
      padding: 4px 6px 0;
      overflow-x: hidden;
      overflow-y: scroll;
      background-color: ${theme.color.modalBg};
    }
    .ant-list-item {
      padding: 0;
      text-align: left;
    }
  }
`
export const FilterWrapStyle = (theme: Theme) => css`
  .ant-checkbox-group {
    display: block;
    .ant-checkbox-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 39px;
      margin-bottom: 4px;
      background: ${theme.color.themeTxt};
      border-radius: 6px;
      transition: all 0.3s;
      line-height: 2rem;
      border: 1px solid rgba(37, 114, 118, 0);
      .ant-checkbox {
        display: none;
        & + span {
          width: 100%;
          padding: 0 12px 0 14px;
        }
      }
      &.ant-checkbox-wrapper-checked {
        background: rgba(37, 114, 118, .15);
        border: 1px solid rgba(37, 114, 118, .5);
      }
    }
  }
  .category-name {
    float:left;
    width: 30%;
    color: ${theme.color.modalTxt};
  }
  .league-wrap {
    float: left;
    display:flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    width: calc(70% - 28px);
    /* 기타 - 종목 선택 */
    &.sport {
      width: calc(100% - 22px);
    }
    /* 리그 선택 */
    .league-name {
      flex: 1;
      color: ${theme.color.modalTxt};
    }
  }
  .emblem {
    width: 14px;
    height: auto;
    margin-right: 4px;
  }
  .top {
    display: flex;
    justify-content: center;
    align-items: center;
    width: auto;
    height: 20px;
    border-radius: 50px;
    padding: 0 7px;
    background: ${theme.color.modalyellow};
    &--txt {
      font-size: ${theme.font.small};
      color: ${theme.color.themeTxt};
      transform: translateY(3%);
    }
  }
`

export const ListBtnStyle = (theme: Theme) => css`
  width: 100%;
  height: 39px;
  margin-bottom: 4px;
  padding: 0 12px;
  color: ${theme.color.modalTxt};
  background: ${theme.color.themeTxt};
  border-radius: 6px;
  transition: all 0.3s;
  line-height: 2rem;
  &::before {
    display: none;
  }
`
export const PointStyle = (theme: Theme) => css`
  ${Right};
  width: 22px;
  color: ${theme.color.modalTxt};
`
